export default __webpack_public_path__ + "static/media/globe.af7669a2.svg";